$(function () {

  var filters = {
    all: function () {
      return true;
    },
    below50: function () {
      return ($(this).data('size') < 50);
    },
    from50to100: function () {
      return ($(this).data('size') >= 50 && $(this).data('size') < 100);
    },
    above100: function () {
      return ($(this).data('size') >= 100);
    }
  }
  var getFilter = function(container) {
    return filters[$(container).find('.filters').find('.active').data('filter')];
  }

  window.isotopes = window.isotopes || [];

  $('.reference-gallery').each(function (i,e,a) {
    var container = $(this);
    var grid = $(this).find('.item-grid');
    var loadmore = $(this).find('.loadmore');
    var filters = $(this).find('.filters');

    // Load more functionality

    var showOnStart = $(this).data('showonstart');
    var showOnReload = $(this).data('showonreload');
    var current = showOnStart;

    if(showOnStart != 'all' && showOnStart < grid.children().length) {
      grid.children().each(function (index) {
        if(index < current) {
          $(this).toggleClass('hidden',false);
        } else {
          $(this).toggleClass('hidden',true);
        }
      })

      loadmore.on('click',function () {
        current = current + showOnReload;

        grid.children().each(function (index) {
          if(index < current) {
            $(this).toggleClass('hidden',false);
          } else {
            $(this).toggleClass('hidden',true);
          }
        })

        window.isotopes[i].isotope('layout');

        if(current >= grid.children().length) {
          loadmore.remove();
        }
      })
    } else {
      loadmore.remove();
    }

    window.isotopes[i] = grid.isotope({
      itemSelector: '.reference-item',
      layoutMode: 'masonry',
      filter: getFilter(container)
    })

    filters.on('click','.filter',function () {
      filters.find('.filter').removeClass('active');
      $(this).addClass('active');

      window.isotopes[i].isotope({
        filter: getFilter(container)
      })
    })

    $(window).on('resize',function () {
      window.isotopes[i].isotope('layout');
    })
  })
})
